import { configureStore, Middleware, Tuple } from '@reduxjs/toolkit';
import { Action, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducer from './reducer';
import rootSaga from './saga';

export type TAppStore = Store<ReturnType<typeof reducer>, Action>;
let store: TAppStore;

function getStore(preloadedState?: any): TAppStore {
  if (store) {
    return store;
  }

  const sagaMiddleware = createSagaMiddleware();
  store = configureStore({
    reducer: reducer,
    // this typecasting is needed to avoid strange type discrepancy between redux-saga and rtk
    middleware: () => new Tuple(sagaMiddleware as Middleware),
    preloadedState,
  });
  sagaMiddleware.run(rootSaga);
  return store;
}

export default getStore;
